import {
  countryOptions,
  type CountryOption,
} from '@webapp/core/components/CountrySelect'
import { type CountryCode } from '@webapp/core/entities/external/Country'
import { Currency } from '@webapp/core/entities/external/Currency'
import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { type LegalEntityFormSchema } from '@webapp/platform/legal-entities/components/LegalEntityForm'
import { type LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'

const toCountryOption = (countryName: string): Nullable<CountryOption> => {
  if (!countryName) {
    return null
  }

  return (
    countryOptions.find((option) => option.name === countryName) ?? {
      code: '' as CountryCode,
      name: countryName,
    }
  )
}

export const mapLegalEntityToFormValues = (
  entity: LegalEntity
): LegalEntityFormSchema => ({
  name: entity.name,
  country: toCountryOption(entity.country),
  externalId: entity.externalId,
  baseCurrency: new Currency({
    id: entity.baseCurrencyId,
    name: entity.baseCurrencyName as CurrencyName,
    rate: 0,
  }),
})
